var Config = {
    initialized: false,
    isDevEnvironment: false,
    wsRootUrl: "/api",
    mapApiKey: "AIzaSyAcCLR15aXJYh45uDIAZDjOpQSYj8r8Jpg",
    mapTheme: "Clariant_2023",
    contactFormTextsRoot: "{4CE2DB49-C138-4618-B14A-B2BBF7664640}",
    init() {
        if (this.initialized) return;
        
        this.wsRootUrl = this.getElementValue("wsurl", this.wsRootUrl);
        this.mapApiKey = this.getElementValue("map-api-key", this.mapApiKey);
        this.mapTheme = this.getElementValue("map-theme", this.mapTheme);
        this.contactFormTextsRoot = this.getElementValue("contactformtexts", this.contactFormTextsRoot);
        this.initialized = true;
    },
    getElementValue(id, defaultValue) {
        var el = document.getElementById(id);
        if (el) return el.value || defaultValue;
        else return defaultValue;
    }
};

export default Config;